import { getRecentProducts, setRecentProducts } from '@/features/products/services'
import { getCookieToken } from '@/libs/cookies'
import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

interface IRecentProduct {
  recentProducts: Product[]
  setRecentProducts: (data: Product[]) => void
  getRecentProducts: () => void
  mergeRecentProducts: () => void
  clearRecentProducts: () => void
}
const initialState = {
  recentProducts: [] as Product[],
}
export const useRecentProductStore = create<IRecentProduct>()(
  devtools(
    persist(
      (set, get) => ({
        recentProducts: initialState?.recentProducts,
        getRecentProducts: async () => {
          const response = await getRecentProducts()
          if (!response) return
          set((state) => ({
            ...state,
            recentProducts: response,
          }))
        },
        setRecentProducts: async (data: Product[] | null) => {
          if (!data) return
          const token = await getCookieToken()
          if (!token) {
            if (data.map((item) => item.id).length === 0) return
            const listRecentNew = get().recentProducts?.filter(
              (item: Product) => !data.find((itm) => itm.uid === item.uid)
            )
            const listIds = data?.map((item) => item.id)
            // setRecentProducts(listIds)
            return set((state) => ({
              ...state,
              recentProducts: [...data, ...listRecentNew],
            }))
          } else {
            const listIds = data?.map((item) => item.id)
            await setRecentProducts(listIds)
            await Promise.resolve(get().getRecentProducts())
          }
        },
        mergeRecentProducts: async () => {
          const listIds = get().recentProducts?.map((item) => item.id)
          setRecentProducts(listIds)
          await Promise.resolve(get().getRecentProducts())
        },
        clearRecentProducts: () => {
          set((state) => ({
            ...state,
            recentProducts: [],
          }))
        },
      }),
      {
        name: 'recent-product-storage',
      }
    )
  )
)
